# These are useful in a keypress event

module.exports = KeyChars = {}

for char in "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('')
  KeyChars[char.toLowerCase().charCodeAt(0)] = char
  KeyChars[char.toUpperCase().charCodeAt(0)] = char

namedKeys =
  ' ': 'Space'
  '?': 'QuestionMark'
  ',': 'Comma'
  '.': 'Period'
  '/': 'ForwardSlash'
  '<': 'AngleLeft'
  '>': 'AngleRight'
  ';': 'Semicolon'

for char, name of namedKeys
  KeyChars[char.charCodeAt(0)] = name



// WEBPACK FOOTER //
// ./app/scripts/data/key-chars.coffee